import type { DemoProductItem } from '../hooks/demo';
import type { ProductObject } from '../redux/productSlice';
import {
  getEffectiveQuantity,
  getEffectiveSellingPrice,
  getPriceRangeDisplay,
  isVariantProduct,
} from './variantHelpers';

/** Map demo product → ProductDetailBottomSheet / Product card shape. */
export function toDemoSheetProduct(product: DemoProductItem) {
  const asProduct = product as unknown as ProductObject;
  const hasVariants = isVariantProduct(asProduct);
  const variants = product.bp_product_variants ?? [];

  return {
    category: product.bp_product_category,
    itemname: product.bp_product_name,
    quantity: getEffectiveQuantity(asProduct),
    price: getEffectiveSellingPrice(asProduct) ?? 0,
    mass: product.bp_product_mass,
    unitofmass: product.bp_product_unit_of_mass,
    productID: product._id,
    model: product.bp_product_model,
    size: product.bp_product_size,
    msl: product.bp_minimum_stock_level,
    price_type: product.bp_product_price_type,
    image: product.bp_product_image,
    isFavourite: product.bp_product_is_favourite,
    hasVariants,
    variantCount: variants.length,
    variants,
    variantAttributes: product.bp_product_variant_attributes ?? [],
    priceRangeText: hasVariants
      ? getPriceRangeDisplay(asProduct)
      : undefined,
  };
}

export function demoProductInStock(product: DemoProductItem): boolean {
  return getEffectiveQuantity(product as unknown as ProductObject) > 0;
}
